// Client-only analytics initializer. Reads Vite env vars VITE_GA_ID and VITE_YM_ID
// and injects the respective scripts. This file must only be imported on the client.

const GA_ID = (import.meta as any).env?.VITE_GA_ID as string | undefined
const YM_ID = (import.meta as any).env?.VITE_YM_ID as string | undefined

function injectScript(src: string, attrs: Record<string,string|boolean> = {}) {
  const s = document.createElement('script')
  s.src = src
  if (attrs.async) s.async = true
  if (attrs.defer) s.defer = true
  Object.keys(attrs).forEach(k => {
    if (k === 'async' || k === 'defer') return
    s.setAttribute(k, String(attrs[k]))
  })
  document.head.appendChild(s)
  return s
}

export function initAnalytics() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  try {
    // Google Analytics (gtag.js)
    if (GA_ID) {
      // load gtag
      injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`, { async: true })
      // init gtag
      const inline = document.createElement('script')
      inline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${GA_ID}', { 'send_page_view': true });`
      document.head.appendChild(inline)
    }

    // Yandex Metrika
    if (YM_ID) {
      // updated async snippet from Yandex (includes scripts dedupe check and ecommerce option)
      const ymInline = document.createElement('script')
      ymInline.type = 'text/javascript'
      ymInline.innerHTML = `(function(m,e,t,r,i,k,a){\n        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n        m[i].l=1*new Date();\n        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)\n      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym');\n\n      ym(${YM_ID}, 'init', {webvisor:true, clickmap:true, ecommerce:\"dataLayer\", accurateTrackBounce:true, trackLinks:true});`
      document.head.appendChild(ymInline)

      // noscript fallback image
      const noscript = document.createElement('noscript')
      noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${YM_ID}" style="position:absolute; left:-9999px;" alt="" /></div>`
      document.body.appendChild(noscript)
    }
  } catch (e) {
    // swallow errors to avoid breaking app
    // eslint-disable-next-line no-console
    console.warn('analytics init failed', e)
  }
}

export default initAnalytics
